import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faTicketAlt, faWarehouse, faGlobe, faMapMarkerAlt, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import 'moment/locale/es';
import { getCurrencyValue, renderPrice } from '../../libs/cartLib';
import { useAnalytics } from "libs/analytics";
import { useCart } from "libs/cartLib";
import { renderVenueBadge, renderSectionBadge, renderItemPriceDetail, renderSeatInfo } from './ticketHelpers';

export function CartItemsList({ cart, props, showEmptyCart = true }) {
  const { trackEvent } = useAnalytics();
  const { removeCartItems } = useCart();

  async function handleRemoveFromCartButton(item_id) {
    trackEvent({
      action: "Clicked Remove from Cart Button",
      category: "PurchaseFunnel"
    });
    const items = [item_id];
    await removeCartItems({ items });
    window.location.reload();
  }

  let items = cart ? cart.items || [] : [];
  const tickets = items.filter(i => i.type === 'TICKET').map(t => {
    return !props.totalsOnly ? (
      <div className="cart-item cart-item-ticket cart-item-card" key={t._id}>
        <div className="cart-item-info">
          <div className="cart-item-image">
            <img src={t.image || '/img/placeholder.png'} alt="event" />
          </div>
          <div>
            <div className="cart-item-badges">
              {renderVenueBadge(t)}
              {renderSectionBadge(t)}
            </div>
            <div className="cart-item-title cart-item-title-large">
              {t.title}
            </div>
            <div className="cart-item-date">{t.show_date ? moment(t.show_date).locale('es').format('ddd, D [de] MMMM [de] YYYY - HH:mm') : ''}</div>
            <div className="cart-item-ticket-type"><FontAwesomeIcon icon={faTicketAlt} style={{marginRight: 6}} />{t.description}</div>
            <div className="cart-item-seat-info">{renderSeatInfo(t)}</div>
            <div className="cart-item-description cart-item-access-note">
              {t.note ? t.note : 'Acceso presencial. Presenta el código QR en la entrada del evento.'}
            </div>
            { t.bundle_items && (
              <div className="cart-item-bundle-info">
                { t.bundle_items.map((item, idx) => (
                  <div key={idx}>• {item.quantity} x {item.description}</div>
                )) }
              </div>
            ) }
            <div className="cart-item-numbers">
              <div className="cart-item-actions">
                {!props.readOnly &&
                  <a href="#" className="cart-item-remove" onClick={() => handleRemoveFromCartButton(t._id)}>
                    <FontAwesomeIcon icon={faTrash} /> Eliminar
                  </a>
                }
              </div>
              {/* <div className="cart-item-qty-row">
                <span className="cart-item-qty-label">Cantidad:</span>
                <select className="cart-item-qty-select" value={t.quantity} readOnly>
                  <option value={1}>1</option>
                </select>
              </div> */}
              <div className="cart-item-price cart-item-price-bold">
                {renderItemPriceDetail(cart, t)}                
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : null;
  });
  return (
    <>
      {items.length === 0 ? ( showEmptyCart ? (
        <div className="cart-empty-card">
          <div className="cart-empty-icon">
            <FontAwesomeIcon icon={faTicketAlt} size="3x" />
          </div>
          <div className="cart-empty-title">Tu carrito está vacío</div>
          <div className="cart-empty-message">Agrega boletos para comenzar tu experiencia.<br/>¡La música y los eventos te esperan!</div>
        </div>
      ) : null ) : (
        <>
          <div className="cart-item-group">{tickets}</div>
          <div className="cart-reservation-notice">
            <FontAwesomeIcon icon={faInfoCircle} style={{marginRight: 8}} />
            Los boletos se reservarán durante 10 minutos. Completa tu compra antes de que expire el tiempo.
          </div>
        </>
      )}
    </>
  );
} 